export default {
  name: 'App',
  components: {
    // ARJS                   //直接进入ARJS组件
  },
  mounted() {
    // console.log('App mounted!')
  }
};